import { inject, InjectionToken } from '@angular/core';

interface FooterItem {
    label: string;
    link: string;
    title?: string;
    external?: boolean;
}

function footerItemsFactory() {
    return [] as FooterItem[];
}

const FOOTER_ITEMS = new InjectionToken<FooterItem[]>('FOOTER_ITEMS', {
    factory: footerItemsFactory
});

export const injectFooterItems = () => inject(FOOTER_ITEMS);

export const provideFooterItems = (items: FooterItem[]) => ({
    provide: FOOTER_ITEMS,
    useValue: items
});
